
// Mutations
export const RESETSIGNUPS = 'RESETSIGNUPS';

// Actions
export const SELECTSIGNUP = 'SELECTSIGNUP';
export const ONDROPSIGNUP = 'ONDROPSIGNUP';
export const ONDROPSIGNUPSWAP = 'ONDROPSIGNUPSWAP';
export const REMOVEINVALIDSIGNUPS = 'REMOVEINVALIDSIGNUPS';
export const CREATEMANUALSIGNUP = 'CREATEMANUALSIGNUP';
export const SETCOMMENT = 'SETCOMMENT';
export const SETSUBBEDIN = 'SETSUBBEDIN';
export const SETDROPPEDOUT = 'SETDROPPEDOUT';
export const SETNOSHOW = 'SETNOSHOW';
export const SETBENCHCHECKIN = 'SETBENCHCHECKIN';
export const SETRAIDLEADER = 'SETRAIDLEADER';
export const SETMASTERLOOTER = 'SETMASTERLOOTER';

import db from '../../firebase/firebase'
import {
  generateUpdatesForSingleSignup,
  signupSwapUpdate,
  signupUpdate } from '../helpers/updates'
import { snapshots2objects } from '../helpers/general';
import { updateBound } from '../helpers/binding';
  
export default {
  state: () => ({
    signups: [],
    selectedSignupID: 0,
  }),

  getters: {
    getRaidEventSignups: ( state ) => ( eventid ) => {
      return state.signups.filter( s => s.eventid == eventid )
    },
    getTeamRaidEventSignups: ( state ) => ( eventid, teamkey ) => {
      return state.signups.filter( s => s.eventid == eventid
                                        && s.team == teamkey )
    },
    getPlayerSignups: ( state ) => ( playerid ) => {
      return state.signups.filter( s => s.playerid == playerid
                                        && !s.absent )
    },
  },

  mutations: {
    // The mutations below are for batches of changes
    // This is super-required for performance-reasons
    // Because everytime state.signups is touched, all the Reactive stuff triggers
    // These operations do not preserve any kind of ordering
    addBoundSignupBatch: ( state, arrayOfSnapshots ) => {
      const arrayOfObjects = snapshots2objects( arrayOfSnapshots )

      state.signups = state.signups.concat( arrayOfObjects )
    },
    removeBoundSignupBatch: ( state, arrayOfSnapshots ) => {
      const keysToRemove = arrayOfSnapshots.map( snapshot => { return snapshot.key })
      state.signups = state.signups.filter( s => !keysToRemove.includes( s['.key'] ) )
    },
    updateBoundSignup: ( state, { snapshot } ) => updateBound( state.signups, snapshot ),

    [RESETSIGNUPS] ( state ) {
      state.signups = []
      state.selectedSignupID = 0
      state.playerSignups = {}
      state.eventBenchSignups = {}
      state.eventUnplannedSignups = {}
      state.eventTeamSignups = {}
    },

    [SELECTSIGNUP] ( state, signup ) {
      if( signup ) state.selectedSignupID = signup['.key']
      else state.selectedSignupID = 0
    },
  },

  actions: {
    [ONDROPSIGNUP] ( { rootState }, { event, target } ) {
      const signupid      = event.dataTransfer.getData( 'signupid' );
      const sourceeventid = event.dataTransfer.getData( 'eventid' );
      // const playerid      = event.dataTransfer.getData( 'playerid' );
      // const sourcespec    = event.dataTransfer.getData( 'spec' );
      // const sourceteam    = event.dataTransfer.getData( 'team' );
      // const sourcestate   = event.dataTransfer.getData( 'state' );
      // const sourcegroup   = event.dataTransfer.getData( 'group' );
    
      const signup = rootState.signups.signups.find( signup => signup['.key'] == signupid )
      if( !signup ) return // Sanity check

      // The signup is for this event
      if( target.raidevent['.key'] != sourceeventid ) return 

      // If the target is not a roster group, store group = null
      let group = null
      if( target.group ) group = target.group
      
      let proceed = false

      // Check whether dropping the signup onto the target is allowed
      if( target.absent ) {
        proceed = !signup.absent
      }
      else if( target.group ) {
        proceed = signup.group != target.group
                  || signup.team != target.team
      }
      else if( target.role ) {
        proceed = signup.state != target.state
                  || target.team && signup.team != target.team['.key']
                  || !target.team && signup.team
                  || signup.group
      }

      if( !proceed ) return

      const newvalues = {
        team: ( target.team ? target.team['.key'] : null ),
        state: ( target.state ? target.state : null ),
        manualabsence: ( target.absent ? true : null ),
        absent: ( target.absent ? true : null ),
        lastmovedby: rootState.authentication.user.myDisplayName,
        lastmovedat: ( new Date() ).getTime(),
        spec: ( target.absent ? 'Absence' : signup.spec ),
        group: group,
      }

      return signupUpdate( db, rootState, signup, newvalues )
    },
    [ONDROPSIGNUPSWAP] ( { rootState }, { event, targetsignup } ) {
      const signupid      = event.dataTransfer.getData( 'signupid' );
      const sourceeventid = event.dataTransfer.getData( 'eventid' );
    
      const sourcesignup = rootState.signups.signups.find( signup => signup['.key'] == signupid )
      if( !sourcesignup ) return // Sanity check

      // The signup is for this event
      if( targetsignup.eventid != sourceeventid ) return 

      let proceed = false

      // Check whether dropping the signup onto the target is allowed
      if( targetsignup.absent || sourcesignup.absent ) {
        proceed = false
        // in a swap scenario, this would mean the Spec would be set which would be confusing
      }
      else if( targetsignup.group || sourcesignup.group ) {
        proceed = sourcesignup.group != targetsignup.group
                  || sourcesignup.team != targetsignup.team
      }

      if( !proceed ) return

      const newtargetvalues = {
        team: ( sourcesignup.team ? sourcesignup.team : null ),
        state: ( sourcesignup.state ? sourcesignup.state : null ),
        lastmovedby: rootState.authentication.user.myDisplayName,
        lastmovedat: ( new Date() ).getTime(),
        group: ( sourcesignup.group ? sourcesignup.group : null ),
      }
      const newsourcevalues = {
        team: ( targetsignup.team ? targetsignup.team : null ),
        state: ( targetsignup.state ? targetsignup.state : null ),
        lastmovedby: rootState.authentication.user.myDisplayName,
        lastmovedat: ( new Date() ).getTime(),
        group: ( targetsignup.group ? targetsignup.group : null ),
      }

      return signupSwapUpdate( db, rootState,
                               sourcesignup, newsourcevalues,
                               targetsignup, newtargetvalues )
    },
    [SETCOMMENT] ( { rootState }, { signup, comment } ) {
      const newvalues = {
        comment: ( comment != "" ? comment : null ),
        commentat: ( new Date() ).getTime(),
        commentby: rootState.authentication.user.myDisplayName,
      }
      return signupUpdate( db, rootState, signup, newvalues )
    },
    [SETSUBBEDIN] ( { rootState }, { signup, value } ) {
      const newvalues = {
        subbedin: ( value ? value : null ),
        substateat: ( new Date() ).getTime(),
        substateby: rootState.authentication.user.myDisplayName,
      }
      return signupUpdate( db, rootState, signup, newvalues )
    },
    [SETDROPPEDOUT] ( { rootState }, { signup, value } ) {
      const newvalues = {
        droppedout: ( value ? value : null ),
        substateat: ( new Date() ).getTime(),
        substateby: rootState.authentication.user.myDisplayName,
      }
      return signupUpdate( db, rootState, signup, newvalues )
    },
    [SETNOSHOW] ( { rootState }, { signup, value } ) {
      const newvalues = {
        noshow: ( value ? value : null ),
        substateat: ( new Date() ).getTime(),
        substateby: rootState.authentication.user.myDisplayName,
      }
      return signupUpdate( db, rootState, signup, newvalues )
    },
    [SETBENCHCHECKIN] ( { rootState }, { signup, value } ) {
      const newvalues = {
        benchcheckin: ( value ? value : null ),
        substateat: ( new Date() ).getTime(),
        substateby: rootState.authentication.user.myDisplayName,
      }
      return signupUpdate( db, rootState, signup, newvalues )
    },
    [SETRAIDLEADER] ( { rootState }, { signup, value } ) {
      const newvalues = {
        raidleader: ( value ? value : null ),
      }
      return signupUpdate( db, rootState, signup, newvalues )
    },
    [SETMASTERLOOTER] ( { rootState }, { signup, value } ) {
      const newvalues = {
        masterlooter: ( value ? value : null ),
      }
      return signupUpdate( db, rootState, signup, newvalues )
    },
    [CREATEMANUALSIGNUP] ( { rootState }, { player, specs, raidevents, tentative, late, bench, absent } ) {
      
      var updates = {}
      var signupsToInvalidate = {}

      // Generate a signup for all raidevents
      for( let raidevent of raidevents ) {

        if( absent ) {
          // Generate one (absence) signup
          let signupkey = db.ref().child( 'lockouts/'
            + rootState.lockouts.selectedLockout['.key']
            + '/signups/' ).push().key;
  
          let newsignup = {
            playerid: player.playerid,
            eventid: raidevent,
            spec: 'Absence',
            name: player.name,
            isprimary: true,
            timestamp: (new Date()).getTime(),
            tentative: false,
            late: false,
            bench: false,
            absent: true,
            valid: true,
            manualadd: true,
          }
          Object.defineProperty( newsignup, '.key', { value: signupkey, enumerable: false } )
      
          generateUpdatesForSingleSignup( updates,
            'lockouts/' + rootState.lockouts.selectedLockout['.key'] + '/signups/',
            '', rootState.signups.signups, newsignup, signupsToInvalidate )
        }
        else {
          // Generate a signup for all specs
          for( let spec of specs ) {
            let signupkey = db.ref().child( 'lockouts/'
              + rootState.lockouts.selectedLockout['.key'] + '/signups/' ).push().key;

            let newsignup = {
              playerid: player.playerid,
              eventid: raidevent,
              spec: spec,
              name: player.name,
              isprimary: true,
              timestamp: (new Date()).getTime(),
              tentative: tentative,
              late: late,
              bench: bench,
              absent: false,
              valid: true,
              manualadd: true,
            }
            Object.defineProperty( newsignup, '.key', { value: signupkey, enumerable: false } )
        
            generateUpdatesForSingleSignup( updates,
              'lockouts/' + rootState.lockouts.selectedLockout['.key'] + '/signups/',
              '', rootState.signups.signups, newsignup, signupsToInvalidate )
          }
        }
      }

      return db.ref().update( updates )
    },
    [REMOVEINVALIDSIGNUPS] ( { state, rootState } ) {
      let lockout = rootState.lockouts.selectedLockout
      let destination = rootState.destinations.selectedDestination

      if( lockout ) {
        var updates = {}
        let invalidsignups = state.signups.filter( s => !s.valid)
        for( var sign of invalidsignups ) {
          updates[  'lockouts/' + lockout['.key'] +
                    '/signups/' + sign['.key'] ] = null
        }

        // Mark lockout as no longer up-to-date (for attendance overview)
        updates[ 'destinationLockouts/' + destination['.key'] +
                 '/lockouts/' + lockout['.key'] +
                 '/uptodateattendanceoverview' ] = false

        return db.ref().update( updates )
      }
    },
  },
}